module.exports = __webpack_public_path__ + "img/whatsapp.7611f024.png";